import { render, staticRenderFns } from "./RedoKeyHandler.vue?vue&type=template&id=8874c9c4&"
import script from "./RedoKeyHandler.vue?vue&type=script&lang=ts&"
export * from "./RedoKeyHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports